import { render, staticRenderFns } from "./ViewPointSingle.vue?vue&type=template&id=6be21476&scoped=true"
import script from "./ViewPointSingle.vue?vue&type=script&lang=js"
export * from "./ViewPointSingle.vue?vue&type=script&lang=js"
import style0 from "./ViewPointSingle.vue?vue&type=style&index=0&id=6be21476&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be21476",
  null
  
)

export default component.exports